"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OriginationAutopayPromptState = exports.OriginationAutopayElectionConsentInfoVersion = exports.OriginationAutopayElectionDecision = exports.OriginationDrawConsentInfoVersion = exports.EarlyBankConnectionVerificationOutcome = exports.SupportedDepositorySubtype = exports.EarlyBankConnectionOfferCategory = exports.OriginationDrawConsentType = void 0;
var OriginationDrawConsentType;
(function (OriginationDrawConsentType) {
    OriginationDrawConsentType["FullRequirementAsCashOutAutoDisbursement"] = "FullRequirementAsCashOutAutoDisbursement";
    /**
     * Auto-disburse the full activation requirement as a debt-swap portion (against the preselected debt-swap
     * tradelines carried on the accepted offer) plus the remaining cash-out portion, both from a single consent
     * captured at early-bank-connection time. Registered on the applicant's behalf without a further in-app
     * tradeline-selection step. Only one origination draw consent exists per account.
     */
    OriginationDrawConsentType["FullRequirementDebtSwapAndCashoutAutoDisbursement"] = "FullRequirementDebtSwapAndCashoutAutoDisbursement";
    /**
     * The SuperCLI / MOAP→AC engagement cash-out confirmation. The consent captures the confirmed destination account
     * for audit, but origination never disburses it: the churn balance-sweep money path reads the confirmed selection
     * from the churn treatment metadata and moves the money. Its own draw type so the upfront registration coordinator
     * refuses it structurally (in its switch) rather than routing it to a disbursing module.
     */
    OriginationDrawConsentType["EngagementCashOutViaChurnMoneyPath"] = "EngagementCashOutViaChurnMoneyPath";
})(OriginationDrawConsentType || (exports.OriginationDrawConsentType = OriginationDrawConsentType = {}));
/**
 * The offer category an early-bank-connection-eligible loan application falls into. Each category is
 * gated by its own experiment group so it can be rolled out at an independent percentage, and drives
 * which copy the frontend shows (regular vs debt-payoff) and which draw consent type is recorded.
 * First-lien refi is intentionally absent: it is excluded at snapshot time and never reaches the
 * read-time gate.
 *
 * `engagementCashOut` reuses this surface for the SuperCLI / MOAP→AC churn cash-out confirmation, on its own experiment group.
 */
var EarlyBankConnectionOfferCategory;
(function (EarlyBankConnectionOfferCategory) {
    EarlyBankConnectionOfferCategory["regular"] = "regular";
    EarlyBankConnectionOfferCategory["helocRefi"] = "helocRefi";
    EarlyBankConnectionOfferCategory["debtSwap"] = "debtSwap";
    EarlyBankConnectionOfferCategory["engagementCashOut"] = "engagementCashOut";
})(EarlyBankConnectionOfferCategory || (exports.EarlyBankConnectionOfferCategory = EarlyBankConnectionOfferCategory = {}));
var SupportedDepositorySubtype;
(function (SupportedDepositorySubtype) {
    SupportedDepositorySubtype["checking"] = "checking";
    SupportedDepositorySubtype["savings"] = "savings";
})(SupportedDepositorySubtype || (exports.SupportedDepositorySubtype = SupportedDepositorySubtype = {}));
/**
 * What the applicant should do next after an early-bank-connection attempt. The backend maps every GIACT outcome onto
 * exactly one of these, so the frontend branches on this alone rather than inferring a next step from booleans.
 */
var EarlyBankConnectionVerificationOutcome;
(function (EarlyBankConnectionVerificationOutcome) {
    EarlyBankConnectionVerificationOutcome["verified"] = "verified";
    /**
     * An ops review of an uploaded bank statement can recover this account. Only returned when the applicant is enrolled
     * in the statement-upload experiment — the controller downgrades to `tryDifferentAccount` otherwise.
     */
    EarlyBankConnectionVerificationOutcome["documentUploadRequired"] = "documentUploadRequired";
    /** We'll prompt the user to try a personal account */
    EarlyBankConnectionVerificationOutcome["businessAccountFailedAutomaticVerification"] = "businessAccountFailedAutomaticVerification";
    /** No upload can fix it (deny-listed bank, invalid routing, cannot-be-verified), or the fallback is not available here. */
    EarlyBankConnectionVerificationOutcome["tryDifferentAccount"] = "tryDifferentAccount";
})(EarlyBankConnectionVerificationOutcome || (exports.EarlyBankConnectionVerificationOutcome = EarlyBankConnectionVerificationOutcome = {}));
/** Discriminator for the version of the consent info. */
var OriginationDrawConsentInfoVersion;
(function (OriginationDrawConsentInfoVersion) {
    OriginationDrawConsentInfoVersion["v1"] = "v1";
})(OriginationDrawConsentInfoVersion || (exports.OriginationDrawConsentInfoVersion = OriginationDrawConsentInfoVersion = {}));
/** The applicant's answer to the origination autopay prompt. */
var OriginationAutopayElectionDecision;
(function (OriginationAutopayElectionDecision) {
    OriginationAutopayElectionDecision["optIn"] = "optIn";
    OriginationAutopayElectionDecision["decline"] = "decline";
})(OriginationAutopayElectionDecision || (exports.OriginationAutopayElectionDecision = OriginationAutopayElectionDecision = {}));
/** Discriminator for the version of the autopay election consent info. */
var OriginationAutopayElectionConsentInfoVersion;
(function (OriginationAutopayElectionConsentInfoVersion) {
    OriginationAutopayElectionConsentInfoVersion["v1"] = "v1";
})(OriginationAutopayElectionConsentInfoVersion || (exports.OriginationAutopayElectionConsentInfoVersion = OriginationAutopayElectionConsentInfoVersion = {}));
/**
 * Whether either entry point should show the autopay opt-in screen. Narrow by design: the frontend branches on this
 * alone rather than re-deriving prompt eligibility from the election status.
 */
var OriginationAutopayPromptState;
(function (OriginationAutopayPromptState) {
    /** Verified account with no election on file - show the prompt. */
    OriginationAutopayPromptState["show"] = "show";
    /** Already opted in or declined - never re-prompt. */
    OriginationAutopayPromptState["answered"] = "answered";
    /** No verified account to enroll against, or the application is not eligible. */
    OriginationAutopayPromptState["notApplicable"] = "notApplicable";
})(OriginationAutopayPromptState || (exports.OriginationAutopayPromptState = OriginationAutopayPromptState = {}));
